import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, HelpersService } from '@evento-ng/libs';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-review-details-mobile',
  templateUrl: './review-details-mobile.component.html',
  styleUrls: ['./review-details-mobile.component.scss'],
})
export class ReviewDetailsMobileComponent {
  @Input() event: any;
  @Input() invoice: any;
  @Output() detailsMobileOpened = new EventEmitter();
  isSalesMan = false;
  user: any;
  openPlolicies = false;
  constructor(
    public helpers: HelpersService,
    public ticketService: TicketService,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.user = this.authService.user.getValue();
  }
}
